import type { ResumeDto } from "@reactive-resume/dto";

import { axios } from "@/client/libs/axios";

export const findResumeById = async (data: { id: string }) => {
  const response = await axios.get<ResumeDto>(`/resume/${data.id}`);

  return response.data;
};

export const findResumeByEmailSlug = async (data: { email: string; slug: string }) => {
  const response = await axios.get<ResumeDto>(`/resume/public/${data.email}/${data.slug}`);

  return response.data;
};
